import { APP_NAME, LOGOS } from '@/lib/brand';

/**
 * The group's logos and the platform's name, for the sign-in screens.
 * The artwork has a white ground, so it sits on a white plate in either
 * theme. Side by side on a tablet or desktop; stacked on a phone.
 */
export function BrandLogos({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand-logos${compact ? ' brand-logos--compact' : ''}`}>
      <div className="brand-logos__plate">
        <img src={LOGOS.suremix} alt="Suremix Readymix Concrete" className="brand-logos__suremix"
          width={1200} height={396} decoding="async" />
        <img src={LOGOS.cpp} alt="CPP Coastal Precast & Paving" className="brand-logos__cpp"
          width={960} height={390} decoding="async" />
      </div>
      <h1 className="brand-logos__name">{APP_NAME}</h1>
      <p className="muted small brand-logos__sub">Quarry · Concrete · Workshop · Management</p>
    </div>
  );
}
